<agpr-panel
    *ngIf="preferences"
    header="AMT.targeting"
>
    <agpr-checkbox
        id="targetingPreferences_influencerStreams"
        class="agpr-influencerstreams"
        [(ngModel)]="preferences.hasInfluencerStreams"
        label="Core.navigation.mediaRelations.influencerStreams"
        [disabled]="isReadOnly"
        [binary]="true"
    ></agpr-checkbox>
    <agpr-checkbox
        id="targetingPreferences_mentionLinks"
        class="agpr-mentionLinks-checkbox"
        [(ngModel)]="preferences.mentionLinksEnabled"
        [disabled]="hasMonitoring || isReadOnly"
        label="AMT.targeting.mentionLinks"
        [infoCircleTooltip]="hasMonitoring ? 'AMT.targeting.mentionLinks.tooltip' : null"
        [binary]="true"
    >
    </agpr-checkbox>
    <div class="agpr-export-container">
        <agpr-dropdown
            [(ngModel)]="preferences.csvExportLimit"
            [options]="csvExportOptions"
            label="AMT.targeting.exportLimit"
            [disabled]="isReadOnly"
            placeholder="None"
            [bindToValue]="true"
            [allowNull]="true"
        ></agpr-dropdown>
    </div>
    <agpr-include-exclude-chips
        id="accountManagement.geoRestrictions"
        headerLabel="AMT.targeting.regionalRestrictions"
        [disabled]="isReadOnly"
        [placeholder]="'Discover.targeting.searchFieldLabels.search.placeholder'"
        [autocompleteOptions]="{
            suggestionsFetcher: journodexRegionsService.searchGeographicLocations.bind(journodexRegionsService)
        }"
        idField="collectionId"
        labelLookupField="displayString"
        [showIncludeAll]="false"
        [(idModel)]="preferences.geography"
        [lookupById]="journodexRegionsService.getByGeographyIds.bind(journodexRegionsService)"
        (browseAll)="openRegionBrowser($event)"
        headingLevel="4"
    ></agpr-include-exclude-chips>
</agpr-panel>
<agpr-panel
    *ngIf="preferences"
    header="AMT.targeting.distributions.recipientQuotaPeriod"
    [marginTop]="20"
>
    <agpr-message
        *ngIf="!quotaInfo?.nextResetDate"
        class="agpr-targetingquota-message"
        severity="info"
    >
        {{ 'AMT.targeting.targetingquota.calculating' | localize }}
    </agpr-message>
    <div *ngIf="quotaInfo?.nextResetDate">
        <agpr-message
            *ngIf="displayCustomDateBanner"
            severity="info"
        >
            <span>{{ 'AMT.targeting.targetingquota.customQuota' | localize }}</span>
            <agpr-button
                [label]="'AMT.targeting.targetingquota.customQuota.reset' | localize: {
                    date: originalQuotaResetDate | date: userPrefs.getDateFormatString()
                }"
                [style]="buttonTypesEnum.link"
                (click)="resetToSystemResetDate()"
                class="agpr-distributions-resetLink"
            ></agpr-button>
        </agpr-message>
        <div class="agpr-distributions-dateRange">
            <div class="agpr-distributions-dateRange-section">
                <label>{{ 'AMT.targeting.targetingquota.quotaPeriod.startDate' | localize }}</label>
                <agpr-date-picker
                    [id]="id +'_accountStartDate'"
                    [(ngModel)]="quotaStartDate"
                    [ariaLabelledBy]="id + '_accountDateLabel'"
                    [disabled]="true"
                ></agpr-date-picker>
            </div>
            <div class="agpr-distributions-dateRange-section">
                <label>{{ 'AMT.targeting.targetingquota.quotaPeriod.startTime' | localize }}</label>
                <agpr-time-picker
                    [id]="id + '_startTime'"
                    [(ngModel)]="startTime"
                    [showTimeZoneSelector]="false"
                    [header]="'time' | localize"
                    [disabled]="true"
                ></agpr-time-picker>
            </div>
        </div>
        <div class="agpr-distributions-dateRange">
            <div class="agpr-distributions-dateRange-section">
                <label>{{ 'AMT.targeting.targetingquota.quotaPeriod.endDate' | localize }}</label>
                <agpr-date-picker
                    [id]="id +'_accountResetDate'"
                    [defaultDate]="nextResetDate"
                    [(ngModel)]="nextResetDate"
                    [ariaLabelledBy]="id + '_accountResetDate'"
                    [minDate]="currentDate"
                    (ngModelChange)="nextResetDateTimeChanged()"
                ></agpr-date-picker>
            </div>
            <div class="agpr-distributions-dateRange-section">
                <label>{{ 'AMT.targeting.targetingquota.quotaPeriod.endTime' | localize }}</label>
                <agpr-time-picker
                    [id]="id + '_resetDateTime'"
                    [(ngModel)]="nextResetTime"
                    [showTimeZoneSelector]="false"
                    [header]="'time' | localize"
                    (changeHour)="nextResetDateTimeChanged()"
                    (changeMinute)="nextResetDateTimeChanged()"
                    (changeMeridian)="nextResetDateTimeChanged()"
                ></agpr-time-picker>
            </div>
        </div>
    </div>
</agpr-panel>
<agpr-panel
    *ngIf="preferences"
    header="AMT.targeting.distributions.distributionRecipients"
    [paddingBottom]="0"
    [marginTop]="20"
>
    <div class="agpr-distributions-content">
        <div class="agpr-column">
            <agpr-number-input
                id="targetingPreferences.baselineDistributions"
                [(ngModel)]="preferences.baselineDistributions"
                [disabled]="isReadOnly"
                label="AMT.targeting.distributions.annualRecipients"
                [integerOnly]="true"
                [min]="0"
                [max]="2000000000"
            ></agpr-number-input>
            <agpr-number-input
                id="targetingPreferences.additionalDistributions"
                [(ngModel)]="preferences.additionalDistributions"
                [disabled]="isReadOnly"
                label="AMT.targeting.distributions.additionalRecipients"
                [integerOnly]="true"
                [min]="0"
                [max]="2000000000"
            ></agpr-number-input>
        </div>
        <div class="agpr-column">
            <agpr-text-input
                id="targetingPreferences.usedDistributions"
                [(ngModel)]="preferences.usedDistributions"
                label="AMT.targeting.distributions.usedRecipients"
                [disabled]="true"
            ></agpr-text-input>
            <agpr-text-input
                id="targetingPreferences.quota"
                [ngModel]="+preferences.baselineDistributions + +preferences.additionalDistributions - +preferences.usedDistributions"
                label="AMT.targeting.distributions.remainingRecipients"
                [disabled]="true"
            ></agpr-text-input>
        </div>
    </div>
</agpr-panel>
<agpr-panel
    *ngIf="preferences && showEmailAccountConnectorConfig"
    header='AMT.targeting.3rdPartyEmailClient.title'
>
    <div class="agpr-distributions-content">
        <div class="agpr-column">
            <agpr-number-input
                id="targetingPreferences_3rdPartyEmailClient_shared"
                [(ngModel)]="emailAccountConnectorConfig.sharedConnectorLimit"
                [disabled]="isReadOnly"
                label="AMT.targeting.3rdPartyEmailClient.shared"
                tooltip="AMT.targeting.3rdPartyEmailClient.shared.tooltip"
                [integerOnly]="true"
                [min]="0"
                [max]="10"
                (blur)="checkError(emailAccountPrivacyLevels.SHARED)"
            ></agpr-number-input>
            @if (emailAccountErrors.shared) {
                <agpr-form-message>
                    {{ 'AMT.targeting.3rdPartyEmailClient.shared.limitBelowUsageFeedback' | localize:{numOfAccounts: emailAccountConnectorUsage.sharedUsage} }}
                </agpr-form-message>
            }
        </div>
        <div class="agpr-column">
            <agpr-number-input
                id="targetingPreferences_3rdPartyEmailClient_privatePerUser"
                [(ngModel)]="emailAccountConnectorConfig.privateConnectorLimit"
                [disabled]="isReadOnly"
                label="AMT.targeting.3rdPartyEmailClient.privatePerUser"
                tooltip="AMT.targeting.3rdPartyEmailClient.privatePerUser.tooltip"
                [integerOnly]="true"
                [min]="0"
                [max]="10"
                (blur)="checkError(emailAccountPrivacyLevels.PRIVATE)"
            ></agpr-number-input>
            @if (emailAccountErrors.privatePerUser) {
                <agpr-form-message>
                    {{ 'AMT.targeting.3rdPartyEmailClient.privatePerUser.limitBelowUsageFeedback' | localize:{numOfAccounts: emailAccountConnectorUsage.privateUsage} }}
                </agpr-form-message>
            }
        </div>
    </div>
</agpr-panel>
